/* MCR collection + search grid helpers:
   - <mcr-grid-density>   grid density toggle (desktop 2/3/4, mobile 1/2), remembered in localStorage
   - <mcr-collection-loader> "Load more" / infinite scroll with skeleton loaders (Section Rendering API)
   - [data-mcr-facet-link] links (quick size chips etc.) routed through Dawn's FacetFiltersForm AJAX
   Works after facets.js re-renders #ProductGridContainer because custom elements self-initialise. */
(function () {
  'use strict';
  if (window.__mcrCollectionInit) return;
  window.__mcrCollectionInit = true;

  var KEY_D = 'mcr:grid:d';
  var KEY_M = 'mcr:grid:m';
  var mqDesktop = window.matchMedia('(min-width: 990px)');

  function store(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }
  function read(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  /* ---------- Grid density ---------- */
  function rootFor(el) {
    return el.closest('[data-mcr-grid-root]') || document.querySelector('[data-mcr-grid-root]');
  }

  function updateSizes(root) {
    var d = parseInt(getComputedStyle(root).getPropertyValue('--mcr-cols-d'), 10) || 4;
    var t = parseInt(getComputedStyle(root).getPropertyValue('--mcr-cols-t'), 10) || 3;
    var m = parseInt(getComputedStyle(root).getPropertyValue('--mcr-cols-m'), 10) || 2;
    var sizes =
      '(min-width: 1400px) ' + Math.round(1400 / d) + 'px, (min-width: 990px) calc((100vw - 130px) / ' + d + '), (min-width: 750px) calc((100vw - 120px) / ' + t + '), calc((100vw - 35px) / ' + m + ')';
    root.querySelectorAll('.mcr-card__img[sizes]').forEach(function (img) {
      if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
    });
  }

  class MCRGridDensity extends HTMLElement {
    connectedCallback() {
      this.root = rootFor(this);
      if (!this.root) return;
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.sync();
      updateSizes(this.root);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
    sync() {
      var style = this.root.style;
      var d = style.getPropertyValue('--mcr-cols-d').trim();
      var m = style.getPropertyValue('--mcr-cols-m').trim();
      this.querySelectorAll('[data-cols-d]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cols-d') === d ? 'true' : 'false');
      });
      this.querySelectorAll('[data-cols-m]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cols-m') === m ? 'true' : 'false');
      });
    }
    onClick(event) {
      var btn = event.target.closest('button');
      if (!btn) return;
      if (btn.hasAttribute('data-cols-d')) {
        this.root.style.setProperty('--mcr-cols-d', btn.getAttribute('data-cols-d'));
        store(KEY_D, btn.getAttribute('data-cols-d'));
      } else if (btn.hasAttribute('data-cols-m')) {
        this.root.style.setProperty('--mcr-cols-m', btn.getAttribute('data-cols-m'));
        store(KEY_M, btn.getAttribute('data-cols-m'));
      } else return;
      this.root.classList.add('mcr-grid--switching');
      var root = this.root;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.remove('mcr-grid--switching'); });
      });
      this.sync();
      updateSizes(this.root);
    }
  }
  if (!customElements.get('mcr-grid-density')) customElements.define('mcr-grid-density', MCRGridDensity);

  /* ---------- Load more / infinite scroll ---------- */
  class MCRCollectionLoader extends HTMLElement {
    connectedCallback() {
      this.mode = this.getAttribute('data-mode') || 'load_more';
      this.button = this.querySelector('[data-mcr-load-more]');
      this.loading = false;
      if (!this.button) return;
      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
      if (this.mode === 'infinite' && 'IntersectionObserver' in window) {
        var self = this;
        this.io = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) self.load();
          },
          { rootMargin: '600px 0px' }
        );
        this.io.observe(this);
      }
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
    onClick(event) {
      event.preventDefault();
      this.load();
    }
    skeletons(grid, count) {
      var frag = document.createDocumentFragment();
      for (var i = 0; i < count; i++) {
        var li = document.createElement('li');
        li.className = 'grid__item mcr-skeleton';
        li.setAttribute('aria-hidden', 'true');
        li.innerHTML = '<div class="mcr-skeleton__media"></div><div class="mcr-skeleton__line"></div><div class="mcr-skeleton__line mcr-skeleton__line--short"></div>';
        frag.appendChild(li);
      }
      grid.appendChild(frag);
    }
    load() {
      var next = this.getAttribute('data-next-url');
      var grid = document.getElementById('product-grid');
      if (this.loading || !next || !grid) return;
      this.loading = true;
      this.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');
      this.skeletons(grid, parseInt(this.getAttribute('data-skeletons'), 10) || 4);
      var sectionId = this.getAttribute('data-section-id');
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      var self = this;
      fetch(url)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('#product-grid > li');
          grid.querySelectorAll('.mcr-skeleton').forEach(function (s) {
            s.remove();
          });
          var first = null;
          items.forEach(function (item) {
            item.classList.add('mcr-appended');
            grid.appendChild(item);
            if (!first) first = item;
          });
          var fresh = doc.querySelector('mcr-collection-loader');
          if (fresh && fresh.getAttribute('data-next-url')) {
            self.setAttribute('data-next-url', fresh.getAttribute('data-next-url'));
            var prog = self.querySelector('[data-mcr-progress]');
            var freshProg = fresh.querySelector('[data-mcr-progress]');
            if (prog && freshProg) prog.innerHTML = freshProg.innerHTML;
            self.style.cssText = fresh.style.cssText;
            if (self.button.tagName === 'A') self.button.setAttribute('href', fresh.getAttribute('data-next-url'));
          } else {
            self.removeAttribute('data-next-url');
            if (self.io) self.io.disconnect();
            var done = fresh && fresh.querySelector('[data-mcr-progress]');
            var p = self.querySelector('[data-mcr-progress]');
            if (done && p) p.innerHTML = done.innerHTML;
            self.style.cssText = fresh ? fresh.style.cssText : '';
            self.classList.add('is-complete');
          }
          if (window.MCR && window.MCR.init) window.MCR.init(grid);
          var root = rootFor(self);
          if (root) updateSizes(root);
          if (typeof window.initializeScrollAnimationTrigger === 'function') window.initializeScrollAnimationTrigger(grid);
          if (first && self.mode === 'load_more') {
            var link = first.querySelector('a[href]');
            if (link) link.focus({ preventScroll: true });
          }
          document.dispatchEvent(new CustomEvent('mcr:collection:loaded', { detail: { url: next } }));
        })
        .catch(function (e) {
          console.error(e);
          grid.querySelectorAll('.mcr-skeleton').forEach(function (s) {
            s.remove();
          });
          window.location.href = next;
        })
        .finally(function () {
          self.loading = false;
          self.classList.remove('is-loading');
          self.button.removeAttribute('aria-busy');
        });
    }
  }
  if (!customElements.get('mcr-collection-loader')) customElements.define('mcr-collection-loader', MCRCollectionLoader);

  /* ---------- Facet links (quick size chips, suggestions) through Dawn AJAX ---------- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-mcr-facet-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    var FF = window.FacetFiltersForm;
    if (!FF || !document.getElementById('product-grid') || link.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    var href = link.getAttribute('href') || '';
    var q = href.indexOf('?') > -1 ? href.slice(href.indexOf('?') + 1) : '';
    // drop pagination when filters change
    q = q
      .split('&')
      .filter(function (p) {
        return p && p.indexOf('page=') !== 0;
      })
      .join('&');
    var group = link.closest('[data-mcr-chip-group]');
    if (group) {
      group.classList.add('is-loading');
      if (link.hasAttribute('aria-pressed')) link.setAttribute('aria-pressed', link.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    }
    FF.renderPage(q);
    var target = document.getElementById('ProductGridContainer');
    if (target && link.hasAttribute('data-mcr-scroll')) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  });

  /* Read more / less for collapsible SEO copy */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-mcr-readmore]');
    if (!btn) return;
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.toggle('is-expanded', open);
    var label = btn.querySelector('span');
    if (label) label.textContent = open ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more');
    if (!open) {
      var top = body.getBoundingClientRect().top + window.pageYOffset - 120;
      if (window.pageYOffset > top) window.scrollTo({ top: top });
    }
  });
  /* Hide the toggle when the copy is short enough not to need it */
  function checkReadMore() {
    document.querySelectorAll('[data-mcr-readmore-body]').forEach(function (body) {
      if (body.dataset.mcrChecked) return;
      body.dataset.mcrChecked = '1';
      var limit = parseInt(getComputedStyle(body).maxHeight, 10);
      if (limit && body.scrollHeight <= limit + 24) {
        body.classList.add('is-expanded', 'is-short');
        var btn = document.querySelector('[data-mcr-readmore][aria-controls="' + body.id + '"]');
        if (btn) btn.hidden = true;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkReadMore);
  else checkReadMore();
  document.addEventListener('shopify:section:load', checkReadMore);

  /* Keep density buttons and image sizes in sync after AJAX filter renders */
  document.addEventListener('mcr:facets:rendered', function () {
    document.querySelectorAll('[data-mcr-grid-root]').forEach(updateSizes);
  });
  if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener('change', function () {
      document.querySelectorAll('[data-mcr-grid-root]').forEach(updateSizes);
    });
  }
})();

/* Merged filter values (snippets/facets.liquid): one visible checkbox per clean name ("Blue") with the
   other raw spellings (BLUE, blue, ABLUE…) as hidden twins. Keep the twins in step before Dawn's
   facet form reads its FormData, and let a pill remove every twin at once. */
(function () {
  if (window.__mcrFacetTwins) return;
  window.__mcrFacetTwins = true;
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[type="checkbox"][data-mcr-twin]:not([hidden])') || !t.form) return;
    t.form.querySelectorAll('input[hidden][data-mcr-twin="' + t.dataset.mcrTwin + '"][name="' + t.name + '"]').forEach(function (x) {
      x.checked = t.checked;
    });
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-mcr-twin-remove]');
    if (!a) return;
    var form = document.getElementById('FacetFiltersForm') || document.getElementById('FacetFiltersFormMobile');
    var boxes = form ? form.querySelectorAll('input[data-mcr-twin="' + a.dataset.mcrTwinRemove + '"][name="' + a.dataset.mcrTwinName + '"]') : [];
    if (!boxes.length) return;
    e.preventDefault();
    e.stopPropagation();
    boxes.forEach(function (x) { x.checked = false; });
    form.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
})();

/* Size filter → product page (2026-10-08): with a size filter on, product links carry ?mcr_size=<size>
   so the product opens with that size already picked (assets/mcr-product.js). Rewritten at click time
   because facets re-render the grid. */
(function () {
  if (window.__mcrSizeLink) return;
  window.__mcrSizeLink = true;
  function activeSize() {
    var q = new URLSearchParams(location.search);
    var out = '';
    q.forEach(function (v, k) { if (!out && /^filter\.v\.option\.[^=]*size/i.test(k) && v) out = v; });
    return out;
  }
  function tag(e) {
    var a = e.target.closest && e.target.closest('a[href*="/products/"]');
    if (!a || !a.closest('#ProductGridContainer, #product-grid, .mcr-collection, main')) return;
    var size = activeSize();
    if (!size) return;
    try {
      var u = new URL(a.href, location.origin);
      if (u.origin !== location.origin) return;
      u.searchParams.set('mcr_size', size);
      a.href = u.pathname + u.search + u.hash;
    } catch (err) {}
  }
  document.addEventListener('pointerdown', tag, true);
  document.addEventListener('click', tag, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') tag(e); }, true);
})();
